<template>
    <div class="py-2 bg-dark">
        <div class="container">
            <div class="row">
                <!--<div class="col-xl-4 col-lg-4 col-md-5 col-sm-12 hide-ipad">
                    <div class="top_first"><router-link to="callto:(+84)0123456789" class="medium text-light">(+84) 0123 456 789</router-link></div>
                </div>
                
                <div class="col-xl-4 col-lg-4 col-md-5 col-sm-12 hide-ipad">
                    <div class="top_second text-center"><p class="medium text-light m-0 p-0">Get Free delivery from $2000 <a href="#" class="medium text-dark text-underline">Shop Now</a></p></div>
                </div>
                
                <div class="col-xl-4 col-lg-4 col-md-5 col-sm-12">

                    <div class="currency-selector dropdown js-dropdown float-right">
                        <router-link to="#" data-bs-toggle="dropdown" class="popup-title"  title="Currency" aria-label="Currency dropdown">
                            <span class="hidden-xl-down medium text-light">Currency:</span>
                            <span class="iso_code medium text-light">$USD</span>
                            <i class="fa fa-angle-down medium text-light"></i>
                        </router-link>
                        <ul class="popup-content dropdown-menu">  
                            <li><router-link to="#" title="Euro" class="dropdown-item medium text-muted">EUR €</router-link></li>
                            <li class="current"><router-link to="#" title="US Dollar" class="dropdown-item medium text-muted">USD $</router-link></li>
                        </ul>
                    </div>
                    
                
                    <div class="language-selector-wrapper dropdown js-dropdown float-right me-3">
                        <router-link to="#" class="popup-title" data-bs-toggle="dropdown" title="Language" aria-label="Language dropdown">
                            <span class="hidden-xl-down medium text-light">Language:</span>
                            <span class="iso_code medium text-light">English</span>
                            <i class="fa fa-angle-down medium text-light"></i>
                        </router-link>
                        <ul class="dropdown-menu popup-content link">
                            <li class="current"><router-link to="#" class="dropdown-item medium text-muted"><img :src="image1" alt="en" width="16" height="11" /><span>English</span></router-link></li>
                            <li><router-link to="#" class="dropdown-item medium text-muted"><img :src="image2" alt="fr" width="16" height="11" /><span>Français</span></router-link></li>
                            <li><router-link to="#" class="dropdown-item medium text-muted"><img :src="image3" alt="de" width="16" height="11" /><span>Deutsch</span></router-link></li>
                            <li><router-link to="#" class="dropdown-item medium text-muted"><img :src="image4" alt="it" width="16" height="11" /><span>Italiano</span></router-link></li>
                            <li><router-link to="#" class="dropdown-item medium text-muted"><img :src="image5" alt="es" width="16" height="11" /><span>Español</span></router-link></li>
                            <li ><router-link to="#" class="dropdown-item medium text-muted"><img :src="image6" alt="ar" width="16" height="11" /><span>اللغة العربية</span></router-link></li>
                        </ul>
                    </div>
                    
                    <div class="currency-selector dropdown js-dropdown float-right me-3">
                        <router-link to="#" class="text-light medium">Wishlist</router-link>
                    </div>
                    
                    <div class="currency-selector dropdown js-dropdown float-right me-3">
                        <router-link to="#" class="text-light medium">My Account</router-link>
                    </div>
                </div>-->
                <div class="col-sm-12 hide-ipad">
                    <div class="top_second text-center"><p class="medium text-light m-0 p-0">KUNSTHÅNDVÆRK FRA OVER 200 UDVALGTE KUNSTNERE</p></div>
                </div>
            </div>
        </div>
    </div>
</template>
